export const failPaymentReasons = {
  INSUFFICIENT_FUND: 'checkout.lib.components.paymentOption.insufficientFunds',
  INVALID_PAYMENT_INFO: 'checkout.lib.components.paymentOption.invalidPaymentInfo',
  PAYMENT_DECLINED: 'checkout.lib.components.paymentOption.paymentDeclined',
  PAYMENT_PROCESSING_ERROR: 'checkout.lib.components.paymentOption.paymentProcessingError',
};

const getFailPaymentReason = (type) => {
  return failPaymentReasons[type] || failPaymentReasons.PAYMENT_PROCESSING_ERROR;
};

export default getFailPaymentReason;
